import React from 'react';
import "./BlogPost.css";

import heroshot from "../../Assets/b35/heroshot.jpg"
import img1 from "../../Assets/b35/img1.jpg"
import img2 from "../../Assets/b35/img2.jpg"

function Blog35() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Every Peso Counts</h1>
                    <h6>October 20, 2023 at 3:00 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <div id="blogImages" className="carousel carousel-dark slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        </div>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src={heroshot} className="blog-img" alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src={img1} className="blog-img" alt="..." />
                            </div>
                            <div className="carousel-item">
                                <img src={img2} className="blog-img" alt="..." />
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>Every peso counts — a reminder that even the smallest financial decisions can have a significant impact on our long-term goals. <br />
                        During the talk with Ms. Michelle Go-Mella and Mr. Melvin Mella, we delved into the importance of informed decision-making and investing for the future. That’s why, at MYT, we empower our employees by providing a retirement plan to all our regular full-time employees, ensuring they are financially prepared for tomorrow. </p>
                    <p><a href='https://www.facebook.com/hashtag/mytculture' target='_blank' className='blog-link'>
                        #MYTCulture </a>
                        <a href='https://www.facebook.com/hashtag/financialtalk' target='_blank' className='blog-link'>
                            #FinancialTalk </a>
                        <a href='https://www.facebook.com/hashtag/smartinvestment' target='_blank' className='blog-link'>
                            #SmartInvestment </a>
                        <a href='https://www.facebook.com/hashtag/informeddecisions' target='_blank' className='blog-link'>
                            #Informed Decisions </a>
                        <a href='https://www.facebook.com/hashtag/everypesocounts' target='_blank' className='blog-link'>
                            #EveryPesoCounts </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog35
